import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import A1 from '../Login/Chatbot.jpeg'; // Make sure this path is correct

const ResetPassword = () => {
    const { resetToken } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');

        try {
            const res = await fetch(`https://botapi.emedha.in/auth/api/reset-passwordusers/${resetToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ password }),
            });

            const data = await res.json();

            if (res.ok) {
                setMessage(data.message);
                setTimeout(() => navigate('/'), 2000); // Redirect to login
            } else {
                setError(data.error || 'Something went wrong.');
            }
        } catch (err) {
            console.error(err);
            setError('Server error. Please try again.');
        }

        setLoading(false);
    };

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
            <div className="card shadow p-4" style={{ maxWidth: '400px', width: '100%' }}>

                <div className="text-center mb-3">
                    <h2 className="fw-bold text-primary">
                        Emedha ChatBot <span className="text-success">Services</span>
                    </h2>
                    <img src={A1} alt="ChatBot Services" style={{ width: '100px', borderRadius: '50%' }} />
                    <h4 className="mt-3 mb-2">Reset Password</h4>
                    <p className="text-muted small">
                        Enter your new password to complete the reset process.
                    </p>
                </div>

                {message && <div className="alert alert-success">{message}</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">New Password</label>
                        <input type="password" id="password" className="form-control" placeholder="Enter new password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>

                    <button type="submit" className="btn btn-success w-100" disabled={loading}>
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
